import React from 'react';
import './FeaturesSection.css';
import womanImg from '../assets/feature-image-2.png'; // Add the image manually or use a placeholder

const FeatureSection = () => {
  return (
    <div className="feature-section d-flex align-items-center justify-content-center py-5">
      <div className="container">
        <div className="row align-items-center">
          {/* Left Content with slide-in-left */}
          <div className="col-md-6 text-light slide-in-left">
            <p className="subheading">OUR FEATURES</p>
            <h2 className="heading">Comprehensive Services From<br />Concept To Execution.</h2>
            <p className="description">
              We combine creativity, precision, and passion to craft unforgettable experiences. From bespoke event planning and stunning visual designs to seamless coordination and cutting-edge technology, our features ensure every event runs smoothly and exceeds expectations. Your vision, our execution — flawlessly delivered.
            </p>

            <div className="row g-3 mt-4">
              <div className="col-6">
                <div className="feature-box purple-box">
  <h6>End–To–End Planning</h6>
  <p>From strategy to execution, we handle every detail to ensure seamless project delivery.</p>
</div>
              </div>
              <div className="col-6">
                <div className="feature-box pink-box">
  <h6>Customized Themes</h6>
  <p>Get uniquely crafted themes tailored to reflect your brand’s identity and vision.</p>
</div>
              </div>
              <div className="col-6">
                <div className="feature-box pink-box">
  <h6>Vendor Coordination</h6>
  <p>We manage all vendor communications and logistics to ensure smooth collaboration and timely delivery.</p>
</div>
              </div>
              <div className="col-6">
                <div className="feature-box purple-box">
  <h6>On-Site Management</h6>
  <p>Our dedicated team ensures everything runs smoothly on-site, handling every detail in real time.</p>
</div>
              </div>
            </div>
          </div>

          {/* Right Image with slide-in-right */}
          <div className="col-md-6 mt-4 mt-md-0 slide-in-right">
            <div className="image-box">
              <img src={womanImg} alt="event planner" className="img-fluid rounded-image" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FeatureSection;
